module.exports = __webpack_public_path__ + "img/notice-bg.2e7ea4e1.png";